<template>
  <SoDialog
    ref="enrolment-automated-communication-modal"
    v-model="isOpen"
    class="enrolment-modal"
    :loading="automatedCommunicationQuery?.isLoading"
  >
    <template v-if="automatedCommunicationData?.length">
      <div class="d-flex align-center justify-space-between mb-4">
        <h5>Enrolment Overview</h5>
        <SoStatus :status="enrolment.mappedStatus?.status" />
      </div>
      <SoSimpleTable
        ref="enrolment-overview-table"
        data-testid="enrolment-automated-simple-table"
        :headers="Object.keys(enrolmentDetails)"
        :items="[Object.values(enrolmentDetails)]"
        is-pivoted
        equal-width-columns
      />

      <div class="d-flex align-center justify-space-between mb-4 mt-6">
        <h5>Email Details</h5>
      </div>
      <template
        v-for="(details, index) in automatedCommunicationData"
        :key="`automated_comms_${index}`"
      >
        <SoSimpleTable
          ref="email-overview-table"
          data-testid="enrolment-automated-simple-table"
          :headers="detailsHeaders"
          :items="[overviewDetails(details)]"
          is-pivoted
          equal-width-columns
        />
        <AutomatedCommunicationEmailTemplate
          :email-details="details"
          :enrolment="enrolment"
          class="my-6"
        />
      </template>
    </template>
    <p v-else>No automated communication has been sent for this enrolment</p>
  </SoDialog>
</template>

<script lang="ts">
  import { PropType, defineComponent } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoStatus from "@/components/SoStatus.vue"
  import SoSimpleTable from "@/components/SoSimpleTable.vue"
  import { formatDate } from "@/helpers/dateHelper"
  import { EnrolmentService } from "@/services/operations/EnrolmentService"
  import AutomatedCommunicationEmailTemplate from "./AutomatedCommunicationEmailTemplate.vue"
  import { Enrolment } from "@/models/operations/enrolment/enrolment"

  export default defineComponent({
    components: {
      SoDialog,
      SoSimpleTable,
      SoStatus,
      AutomatedCommunicationEmailTemplate,
    },
    props: {
      modelValue: {
        type: Boolean,
        required: true,
      },
      enrolment: {
        type: Object as PropType<Enrolment>,
        default: null,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        formatDate,
        detailsHeaders: ["Sent to", "Email type", "Time"],
      }
    },
    computed: {
      automatedCommunicationQuery() {
        return EnrolmentService.getEnrolmentAutomatedCommunicationById(
          this.enrolment.id,
        )
      },
      automatedCommunicationData() {
        return this.automatedCommunicationQuery?.data
      },
      enrolmentDetails() {
        return {
          Broker: this.enrolment.broker || "-",
          "Error message": this.enrolment.enrolmentFailureMessage || "-",
          "Third party ref": this.enrolment.thirdPartyReference || "-",
        }
      },
      isOpen: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
    methods: {
      overviewDetails(details) {
        return [
          details.commsSentTo || "",
          details.commsSent || "",
          formatDate(details.createdAt),
        ]
      },
    },
  })
</script>

<style scoped>
  .enrolment-modal__text-layout-grid {
    display: grid;
    grid-template-columns: 2fr 2fr;
    gap: 16px;
  }
</style>
